import Api from './api';

// =====================================================================
// Normalizers — API .NET retorna JSON tudo lowercase sem separadores
// (LowercaseContractResolver / LowercaseCaseNamingPolicy).
// Convertemos para camelCase pra usar idiomaticamente no front.
// USAR `??` (nullish coalescing) — não `||` — para preservar 0/false/''.
// =====================================================================

const normalizeStep = (s) => ({
    stepId: s.stepid ?? s.stepId ?? null,
    audience: s.audience ?? null,
    completed: s.completed ?? false,
    completedAt: s.completedat ?? s.completedAt ?? null,
});

const normalizeProgress = (p) => ({
    firstAccess: p.firstaccess ?? p.firstAccess ?? null,
    totalSteps: p.totalsteps ?? p.totalSteps ?? 0,
    completedSteps: p.completedsteps ?? p.completedSteps ?? 0,
    progressPercent: p.progresspercent ?? p.progressPercent ?? 0,
    allCompleted: p.allcompleted ?? p.allCompleted ?? false,
    steps: Array.isArray(p.steps) ? p.steps.map(normalizeStep) : [],
});

const normalizeMarkStepResponse = (r) => ({
    stepId: r.stepid ?? r.stepId ?? null,
    completedAt: r.completedat ?? r.completedAt ?? null,
    alreadyCompleted: r.alreadycompleted ?? r.alreadyCompleted ?? false,
});

// =====================================================================

const OnboardingService = {
    /**
     * GET /api/onboarding/me
     * Retorna progresso do usuário logado: firstAccess + lista de steps.
     */
    async getMyProgress() {
        try {
            const result = await Api.get('/onboarding/me');
            if (result?.data?.success && result?.data?.data) {
                return normalizeProgress(result.data.data);
            }
            return null;
        } catch (err) {
            Api.kickoff(err);
            return null;
        }
    },

    /**
     * POST /api/onboarding/me/step/{stepId}/complete
     * Marca step manualmente. Usado p/ steps sem evento de domínio
     * (ex.: 'learn-automation-templates' ao terminar mini-tour).
     */
    async markStepComplete(stepId) {
        try {
            const result = await Api.post(`/onboarding/me/step/${encodeURIComponent(stepId)}/complete`);
            if (result?.data?.success && result?.data?.data) {
                return normalizeMarkStepResponse(result.data.data);
            }
            return null;
        } catch (err) {
            Api.kickoff(err);
            return null;
        }
    },

    /**
     * PATCH /api/onboarding/me/first-access
     * Marca first_access = true (Welcome Modal foi visto).
     */
    async markFirstAccessSeen() {
        try {
            const result = await Api.patch('/onboarding/me/first-access');
            return result?.data?.success ?? false;
        } catch (err) {
            Api.kickoff(err);
            return false;
        }
    },
};

export default OnboardingService;
